import "./ObjetivosItem.css";
const ObjetivosItem = ({ icon, titulo, texto, lista }) => {
    return (
        <li className="objetivos__item">
            <h3 className="objetivos__item--titulo"><i className="material-icons">{icon}</i> {titulo}</h3>
            <p className="objetivos__item--texto">{texto}</p>
            {/* Renderização condicional da sublista */}
            {lista && lista.length > 0 && (
                <ul className="objetivos__item--lista">
                    {lista.map((item, index) => (
                        // Usar 'index' como key é aceitável se a lista não mudar de ordem
                        <li key={index} className="objetivos__item--lista---item">
                            {item}
                        </li>
                    ))}
                </ul>
            )}
        </li>
    );
}


export default ObjetivosItem;
